import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Button, Typography } from '@raisin/components-lib';

export const OfferCard = styled(Card)(({ theme }) => ({
  cursor: 'pointer',
  borderRadius: 8,
  border: `1px solid ${theme.palette.grey200.main}`,
}));

export const ProductItem = styled(Grid)(({ theme, $isLongText }) => ({
  [theme.breakpoints.down('lg')]: {
    display: $isLongText ? 'none' : 'block',
  },
}));

export const ProductItemRow = styled(Grid)(({ theme, $isLongText }) => ({
  display: 'none',
  [theme.breakpoints.down('lg')]: {
    display: $isLongText ? 'block' : 'none',
  },
}));

export const HoverContainer = styled('div')(({ theme, $disableHoverEffect }) => ({
  '&:hover': {
    backgroundColor: $disableHoverEffect ? 'inherit' : theme.palette.blue10.main,
  },
}));

export const bankOfferRateValue = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',

  '.MuiTypography-h4': {
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.h4.fontWeight,
    letterSpacing: theme.typography.h4.letterSpacing,
    lineHeight: theme.typography.h4.lineHeight,
  },

  '.MuiTypography-body1': {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.body1.fontWeight,
    letterSpacing: theme.typography.body1.letterSpacing,
    lineHeight: theme.typography.body1.lineHeight,
  },
}));

export const GridContainer = styled(Grid)(({ theme, $isSustainableDeposit, $isTablet }) => ({
  padding: $isSustainableDeposit && !$isTablet ? theme.spacing(4, 6, 0, 6) : theme.spacing(4, 6),
  justifyContent: 'space-between',

  [theme.breakpoints.down('sm')]: {
    padding: $isSustainableDeposit && !$isTablet ? theme.spacing(4, 4, 0, 4) : theme.spacing(4),
    display: 'block',

    '.MuiGrid-root': {
      paddingBottom: theme.spacing(4),

      '&:nth-of-type(2)': {
        paddingBottom: theme.spacing(2),
      },

      '&:last-child': {
        paddingBottom: 0,
      },
    },
  },
}));

export const OfferContainer = styled(Grid)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 0),
  },
  [theme.breakpoints.down('sm')]: {
    display: 'block',

    '.MuiGrid-root': {
      paddingBottom: theme.spacing(4),

      '&:nth-of-type(2)': {
        paddingBottom: theme.spacing(2),
      },

      '&:last-child': {
        paddingBottom: 0,
      },
    },
  },
}));

export const RateGridItem = styled(Grid)(({ theme, $hasMinHeight }) => ({
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: $hasMinHeight ? 60 : 'unset',
  },
}));

export const ProductLabelGrid = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2, 6, 4, 6),
  justifyContent: 'space-between',

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 4, 0, 4),
  },
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey700.main,

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const ProductInfo = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.subtitle2.fontWeight,
}));

export const DepositGuaranteeColumn = styled('span')(({ theme, $isGBR }) => ({
  display: 'flex',
  alignItems: 'center',

  [theme.breakpoints.down('lg')]: {
    minHeight: $isGBR ? 30 : 'unset',
    flexWrap: $isGBR ? 'wrap' : 'unset',
  },
}));

export const DepositGuaranteeImg = styled('img')(({ theme }) => ({
  maxWidth: 100,
  maxHeight: 70,
  display: 'block',
  marginLeft: theme.spacing(2),

  [theme.breakpoints.down('lg')]: {
    maxWidth: 65,
    maxHeight: 30,
  },
}));

export const OrderButton = styled(Button)(({ theme }) => ({
  marginLeft: 'auto',

  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const CtaContainerGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'flex-end',
  gap: theme.spacing(2),

  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(4),
  },

  [theme.breakpoints.down('sm')]: {
    paddingTop: 0,
  },

  [theme.breakpoints.down('xs')]: {
    display: 'block',
  },
}));

export const ChipWrapper = styled('div')({
  display: 'inline-block',
  height: 30,
});
